export enum SponsorCreditScore {
  Unset,
  Bad,
  Poor,
  Okay,
  Good,
  Great,
  Excellent,
}
